import { useContext, createContext, useState, useMemo } from 'react';

type LoadingContextProviderType = {
  children: JSX.Element;
};

type LoadingContextType = {
  isLoading: boolean;
  updateLoadingState: (bool: boolean) => void;
};

const defaultState = {
  isLoading: true,
  updateLoadingState: () => {
    return null;
  },
};

const LoadingContext = createContext<LoadingContextType>(defaultState);

export const LoadingContextProvider = function ({
  children,
}: LoadingContextProviderType): JSX.Element {
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const updateLoadingState = (bool: boolean): void => setIsLoading(bool);

  const values = useMemo(() => {
    return { isLoading, updateLoadingState };
  }, [isLoading]);

  return <LoadingContext.Provider value={values}>{children}</LoadingContext.Provider>;
};

export default function useLoadingContext(): LoadingContextType {
  return useContext(LoadingContext);
}
